import request from "./axios";

function get(key) {
  return request({
    method: "get",
    url: `/reference/${key}`
  })
}

function update(key, data) {
  return request({
    method: "patch",
    url: `/reference/${key}`,
    data: { config: data }
  })
}

const ReferenceService = {
  get, update
};

export default ReferenceService;
